import request from '../utils/request';
import {IEvent} from '../utils/types';

export function fetchNextEventTimeFromStages(query: Object) {
    return request(`/api/next-event-time`, query) as unknown as Promise<IEvent>;
}